import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { BlockComponent } from "@components/container-block/block.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { LabelComponent } from "@components/label/label.component";
import { MultiSelectorComponent } from "@components/multi-selector/multi-selector.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { Observable, of } from "rxjs";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { ITillatnaKvaliteter } from "../../../models/IProduktdefinition";
import { IProduktdefinitionBasdata } from "../../../models/ProduktdefinitionModels";
import { ProduktdefinitionViewModel } from "../../../models/ProduktdefinitionViewModel";

@Component({
    selector: "rask-grunddata",
    templateUrl: "./grunddata.component.html",
    styleUrls: ["./grunddata.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        FormsModule,
        ReactiveFormsModule,
        SelectorComponent,
        MultiSelectorComponent,
        CheckboxComponent,
        LabelComponent,
        InputNumberComponent
    ]
})
export class GrunddataComponent implements OnInit, OnChanges {
    apteringsvillkorLista: string[];
    @Input() basData: IProduktdefinitionBasdata;
    fordelningstyper: string[];
    form: UntypedFormGroup;
    pristyper: string[];
    @Input() rootForm: UntypedFormGroup;
    tillatenKvalitetsList: Observable<ITillatnaKvaliteter[]>;
    @Input() validationContext: IValidationContext;
    @Input() viewModel: ProduktdefinitionViewModel;
    volymlangdkategorier: string[];

    private readonly formBinder = inject(FormBinderService);
    private readonly formId = "produktinstruktioner-details-grunddata";

    ngOnChanges(changes: SimpleChanges): void {
        if (this.form && changes.viewModel && changes.viewModel.currentValue.grunddata !== changes.viewModel.previousValue.grunddata) {
            this.formBinder.reBindForm(this.form, this.viewModel.grunddata);
        }
    }

    ngOnInit(): void {
        this.pristyper = this.basData.pristyper;
        this.fordelningstyper = this.basData.fordelningstyper;
        this.volymlangdkategorier = this.basData.volymlangdkategorier;
        this.apteringsvillkorLista = this.basData.apteringsvillkor;
        this.addTillatenKvalitetToList();
        this.initializeForm();
    }

    tillatenKvalitetsSelectedFormatter = (item: ITillatnaKvaliteter) => item ? item : undefined;

    tillatenKvalitetsViewFormatter = (item: ITillatnaKvaliteter) => `${item.kvalitet}`;

    private addTillatenKvalitetToList() {
        const list = [];
        for (let i = 1; i <= 10; i++) {
            list.push({ kvalitet: i });
        }
        this.tillatenKvalitetsList = of(list);
    }

    private initializeForm() {
        this.form = this.formBinder.CreateGroup(this.viewModel.grunddata);
        this.rootForm.addControl(this.formId, this.form);
        if (!this.viewModel.canEdit) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }
}
